import styled, { css } from 'styled-components';

export const OptionsWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style-type: none;
  margin: 24px 0px 0px 0px;
  max-width: 685px;
  padding: 0px;
`;

export const ListItem = styled.li`
  ${({ theme, $checked }) => css`
    display: flex;
    border-radius: 8px;
    padding: 24px;
    align-items: flex-start;

    ${!$checked && css`
      border: 1px solid ${theme.v2.colors.neutral.highMedium};
    `}
    ${$checked && css`
      border: 2px solid ${theme.v2.colors.brand.primaryMedium};
    `}

    @media (max-width: ${theme.breakpoints.sm}) {
      flex-direction: column;
      padding: 16px;
      justify-content: flex-start;
      gap: 16px;
    }

  `}
`;

export const RadioLabel = styled.label`
  ${({ theme }) => css`
    display: flex;
    cursor: pointer;
    gap: 24px;

    @media (max-width: ${theme.breakpoints.sm}) {
      gap: 8px;
    }
  `}
`;

export const OptionContent = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: flex-start;

  > button {
    padding: 0px;
  }
`;

export const OptionTitle = styled.span`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};

    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `};
`;

export const OptionTag = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    background-color: ${theme.v2.colors.brand.primaryLowLight};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    padding: 4px 8px;
    border-radius: 8px;

    @media (max-width: ${theme.breakpoints.sm}) {
      margin-left: 40px;
    }
  `};
`;

export const OptionDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    text-align: left;
  `};
`;
